import * as React from "react";
import { SVGProps, memo } from "react";

const SvgHello = (props: SVGProps<SVGSVGElement>) => (
  <svg width={80} height={80} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <mask
      id="Hello_svg__a"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={80}
      height={80}
    >
      <path fill="#C4C4C4" d="M0 0h80v80H0z" />
    </mask>

    <g mask="url(#Hello_svg__a)">
      <path
        d="M57.57 73.94c-.07-.9-.57-.53-.52-1.64.05-1.11 1.46-3.42 1.64-4.4a16.894 16.894 0 0 1-.71-4c0-1.23 0-1.52 1.68-4.06 1.86-2.79 2.09-3.22 2.79-3.21a1.27 1.27 0 0 1 1.29.87c.73 1.66-1.09 3.6-.64 4.05.45.45 6.51-.65 6.51-.65 1.92-1.54 6.31-3.21 7.62-2.46a1.229 1.229 0 0 1 .46 1.68 1.29 1.29 0 0 1-.51.5c-2.32 1.59-3.45 2.52-5.65 4.24-.72.55-6.54 3.78-6.54 3.78-.86 5.24-.68 7.86-7.42 5.3ZM30.78 45.56c.259 2.378.191 4.78-.2 7.14a6.228 6.228 0 0 1-.58 1.74 7 7 0 0 1-2.09 2 34.113 34.113 0 0 1-4.65 2 3.34 3.34 0 0 0-1.32 3.72c.63 2.21 2.12 2.63 3.82 3.11.52.162 1.052.289 1.59.38 3.77.65 7.77 1.32 9.9.28 3.12-1.52.83-7 .17-12.45-.55-4.12 1.3-8.48-1.09-9.48-1.86-.72-5.55 1.56-5.55 1.56Z"
        fill="#fff"
        stroke="#272C33"
        strokeWidth={1.58}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M39.12 45.56a26.272 26.272 0 0 0 .2 7.14c.14.613.369 1.203.68 1.75a7.122 7.122 0 0 0 2.09 2c1.498.78 3.052 1.45 4.65 2A3.33 3.33 0 0 1 48 62.17c-.62 2.21-2.12 2.63-3.81 3.11a13.12 13.12 0 0 1-1.59.38c-3.77.65-7.77 1.32-9.9.28-3.12-1.52-.84-7-.17-12.45.51-4.13-1.34-8.54 1-9.49 1.91-.72 5.59 1.56 5.59 1.56Z"
        fill="#fff"
        stroke="#272C33"
        strokeWidth={1.58}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M46.74 58.45a34.1 34.1 0 0 1-4.65-2 7 7 0 0 1-2.09-2 6.275 6.275 0 0 1-.64-1.74 26.214 26.214 0 0 1-.2-7.13 15.067 15.067 0 0 0-2.2-1.1 1.998 1.998 0 0 0-.64-.47 2.94 2.94 0 0 0-1.32-.12 2.9 2.9 0 0 0-1.34.11c-.25.1-.47.261-.64.47-.765.308-1.503.676-2.21 1.1a26.206 26.206 0 0 1-.2 7.13 6.23 6.23 0 0 1-.61 1.74 7 7 0 0 1-2.09 2 34.1 34.1 0 0 1-4.65 2 3.34 3.34 0 0 0-1.32 3.72c.63 2.21 2.12 2.63 3.82 3.11.52.162 1.052.289 1.59.38a35.92 35.92 0 0 0 7.67.79 35.941 35.941 0 0 0 7.68-.79c.538-.091 1.069-.218 1.59-.38 1.7-.46 3.19-.9 3.82-3.11a3.36 3.36 0 0 0-1.37-3.71Z"
        fill="#fff"
      />

      <path
        d="M46.74 58.45a34.1 34.1 0 0 1-4.65-2 7 7 0 0 1-2.09-2 6.275 6.275 0 0 1-.64-1.74 26.214 26.214 0 0 1-.2-7.13 15.067 15.067 0 0 0-2.2-1.1 1.998 1.998 0 0 0-.64-.47 2.94 2.94 0 0 0-1.32-.12 2.9 2.9 0 0 0-1.34.11c-.25.1-.47.261-.64.47-.765.308-1.503.676-2.21 1.1a26.206 26.206 0 0 1-.2 7.13 6.23 6.23 0 0 1-.61 1.74 7 7 0 0 1-2.09 2 34.1 34.1 0 0 1-4.65 2 3.34 3.34 0 0 0-1.32 3.72c.63 2.21 2.12 2.63 3.82 3.11.52.162 1.052.289 1.59.38a35.92 35.92 0 0 0 7.67.79 35.941 35.941 0 0 0 7.68-.79c.538-.091 1.069-.218 1.59-.38 1.7-.46 3.19-.9 3.82-3.11a3.36 3.36 0 0 0-1.37-3.71v0Z"
        stroke="#272C33"
        strokeWidth={1.58}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M25 59.48a68.73 68.73 0 0 0 20.15-.08c-.01.08-.01.16 0 .24a25.14 25.14 0 0 1 4.71 10.17c.25 1.16.41 2.32.58 3.52l.84 6c.24 1.66.47 3.32.65 5 1 9.24.74 18.6 1.81 27.86a.352.352 0 0 0 .09.49h.06-.08A23.007 23.007 0 0 1 46 114l-11 .46a54.14 54.14 0 0 1-7 0 56.064 56.064 0 0 1-11.46-2.61 122.433 122.433 0 0 1 1.21-19.7c1-7 2.61-13.91 3.42-20.93.153-1.908.457-3.8.91-5.66A23.701 23.701 0 0 1 25 59.48Z"
        fill="#CAECD1"
        stroke="#272C33"
        strokeWidth={1.58}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M16.31 93.2c-1-.86 3.52 1.13 3.52 1.13L21 90.64c1.79-3.4-.24-3.85 2.17-9s5-11.55 5.53-14.7a6.83 6.83 0 0 0-.05-2.74 4.41 4.41 0 0 0-3.44-3.72 7.6 7.6 0 0 0-3.32-.14 7.74 7.74 0 0 0-2.07.78A25.93 25.93 0 0 0 12 71.48a50.725 50.725 0 0 0-2 6.15c-1.54 5.61-4.14 9-3.25 12.49.35 1.61 11.55 4.81 9.56 3.08Z"
        fill="#fff"
        stroke="#272C33"
        strokeWidth={1.58}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M50.34 87.42c-2.07-3.23-1.83-2.79-4.65-7.73-2.82-4.94-6-11.08-6.77-14.18a6.79 6.79 0 0 1-.17-2.73 4.42 4.42 0 0 1 3.11-4 7 7 0 0 1 5.42.18A26 26 0 0 1 56 68.61a51.137 51.137 0 0 1 2.49 6c2 5.46 4.95 10.69 6.05 16.39a8.69 8.69 0 0 1-5 9.9c-2.43 1.1-13.2.15-17.8-.57-.47-5.63-.32-10.76.81-12.38 2.83-.24 11.16-.18 14.52-.07M24.84 57.39A34.902 34.902 0 0 0 20 61c-.2.14-6.62 42.72-11.86 99.55a65.604 65.604 0 0 0 22.65.79S33.67 103.15 28 54.88a10.87 10.87 0 0 0-2.79 1.29c-.25.17-.37 1.2-.46 1.49-.43 2-.57 2.54-.88 4.59-.31 2.05-.86 4-1 6a1.54 1.54 0 0 0 0 .64c.106.235.267.44.47.6a51.308 51.308 0 0 0 4.22 3.52l-2.5 4.73a1.09 1.09 0 0 0-.16.52 1 1 0 0 0 .26.48l5.49 8.83"
        fill="#fff"
      />

      <path
        d="M17.09 80.78c-2.32 16.55-5.37 41-8.95 79.74 7 1.45 17.94 1.95 25 .77 0 0 .78-60.59.77-69.44v-3.62C33.33 76.4 29.4 66.51 28 54.88c-.988.292-1.928.726-2.79 1.29-.25.17-.37 1.2-.46 1.49-.43 2-.57 2.54-.88 4.59-.31 2.05-.87 4-1 6a1.54 1.54 0 0 0 0 .64c.103.234.26.44.46.6a63.976 63.976 0 0 0 4.23 3.52l-2.5 4.73a1 1 0 0 0-.16.52c0 .18.14.31.23.47 1.84 2.93 6.3 6.65 8.13 9.59"
        fill="#fff"
      />

      <path
        d="M17.09 80.78c-2.32 16.55-5.37 41-8.95 79.74 7 1.45 17.94 1.95 25 .77 0 0 .78-60.59.77-69.44v-3.62C33.33 76.4 29.4 66.51 28 54.88c-.988.292-1.928.726-2.79 1.29-.25.17-.37 1.2-.46 1.49-.43 2-.57 2.54-.88 4.59-.31 2.05-.87 4-1 6a1.54 1.54 0 0 0 0 .64c.103.234.26.44.46.6a63.976 63.976 0 0 0 4.23 3.52l-2.5 4.73a1 1 0 0 0-.16.52c0 .18.14.31.23.47 1.84 2.93 6.3 6.65 8.13 9.59"
        stroke="#272C33"
        strokeWidth={1.58}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path d="M24.84 57.39c-1.76.86-4.44 3.3-5.33 3.93l5.33-3.93Z" fill="#fff" />

      <path
        d="M24.84 57.39c-1.76.86-4.44 3.3-5.33 3.93"
        stroke="#272C33"
        strokeWidth={1.58}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M45 57.39A35.093 35.093 0 0 1 49.9 61c.19.14 6.61 42.72 11.85 99.55a65.604 65.604 0 0 1-22.65.79s-2.89-58.16 2.76-106.43c.988.292 1.928.726 2.79 1.29.25.17.37 1.2.46 1.49.43 2 .56 2.54.88 4.59.32 2.05.87 4 1 6a1.18 1.18 0 0 1-.51 1.24A56.667 56.667 0 0 1 42.3 73l2.5 4.73c.092.159.147.337.16.52-.022.178-.09.347-.2.49l-5.53 8.82"
        fill="#fff"
      />

      <path
        d="M52.85 81.21c2.32 16.56 5.33 40.55 8.9 79.31-7 1.45-17.94 1.95-25 .77 0 0-.78-60.59-.77-69.44v-3.62c.53-11.83 4.46-21.72 5.83-33.35.988.292 1.928.726 2.79 1.29.25.17.37 1.2.46 1.49.43 2 .56 2.54.88 4.59.32 2.05.87 4 1 6a1.18 1.18 0 0 1-.51 1.24c-1.27 1.24-2.67 2.41-4.13 3.51l2.5 4.73c.092.159.147.337.16.52 0 .18-.14.31-.23.47-1.84 2.93-6.3 6.65-8.14 9.59"
        fill="#fff"
      />

      <path
        d="M52.85 81.21c2.32 16.56 5.33 40.55 8.9 79.31-7 1.45-17.94 1.95-25 .77 0 0-.78-60.59-.77-69.44v-3.62c.53-11.83 4.46-21.72 5.83-33.35.988.292 1.928.726 2.79 1.29.25.17.37 1.2.46 1.49.43 2 .56 2.54.88 4.59.32 2.05.87 4 1 6a1.18 1.18 0 0 1-.51 1.24c-1.27 1.24-2.67 2.41-4.13 3.51l2.5 4.73c.092.159.147.337.16.52 0 .18-.14.31-.23.47-1.84 2.93-6.3 6.65-8.14 9.59"
        stroke="#272C33"
        strokeWidth={1.58}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path d="M45 57.39A35.085 35.085 0 0 1 49.9 61L45 57.39Z" fill="#fff" />

      <path
        d="M45 57.39A35.085 35.085 0 0 1 49.9 61"
        stroke="#272C33"
        strokeWidth={1.58}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="m33.723 81.612-3.506 28.435a1.11 1.11 0 0 0 .966 1.237l20.534 2.533a1.11 1.11 0 0 0 1.237-.966l3.507-28.435a1.11 1.11 0 0 0-.966-1.237l-20.534-2.533a1.11 1.11 0 0 0-1.238.966Z"
        fill="#fff"
        stroke="#272C33"
        strokeWidth={1.58}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M50.06 61.07c2.57 2.46 4.13 3.67 6.29 7.49.43.76 1.2 2.46 2.71 5.87 3.4 7.72 4.48 10.86 5.21 14.42.56 2.79.64 4.55.08 6.42a9 9 0 0 1-3.07 4.73c-1.43 1.05-2 1.41-7.07 2.59-2.66.61-10.88 2.84-12.7 3.12A48.593 48.593 0 0 1 39 98.29a12.488 12.488 0 0 1-.64-3.53c3.21-1.16 17-5.32 18.78-5.58"
        stroke="#272C33"
        strokeWidth={1.58}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M47.63 90.52c.11 1 .5 4 .5 4 2.52 3.59 8.76 2.1 11.34-.54 1.86-1.91 5.15-16 6-20.59-5.11-2.37-7.9-3.72-9.82-3.23-1.19 2.57-6.44 14.7-7.48 17.9l-.54 2.46Z"
        fill="#fff"
      />

      <path
        d="M47.36 94.81a6.65 6.65 0 0 0 5.33 2.43 11.652 11.652 0 0 0 5.43-1.53c1.54-.89 2.54-2.24 4.16-6 1.06-2.51 2.73-12 3.21-16.28a21.237 21.237 0 0 0-4.74-2.49 19.994 19.994 0 0 0-5.09-.74c-2 4-6.26 15.32-6.26 15.32"
        stroke="#272C33"
        strokeWidth={1.58}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M41.75 63a4.51 4.51 0 0 0-1.49 3 4.21 4.21 0 0 0 .43 2 6.34 6.34 0 0 0 3.48 3.11 6.479 6.479 0 0 1-.93-3.11 6.73 6.73 0 0 1 1.48-3.78 13.558 13.558 0 0 1 2.86-2.95 15.32 15.32 0 0 0 3.12-3.67c1.12-1.66 1-4.18.55-6.14-.45-1.96-1.33-4.46-5.39-7.54-1-.93-1.58-.35-1.58-.35a1.098 1.098 0 0 0 0 1.71 6.66 6.66 0 0 1 .47 2.66 15.191 15.191 0 0 1-1.47 4.12c-.5.71-2.08 2.83-2.33 3.11-.25.28-2 1.76-2.25 2.58a4.65 4.65 0 0 0-.53 3.17 7.05 7.05 0 0 0 1.39 2.84A5.67 5.67 0 0 0 40 66c.43 1 .12.6.49 1 .098.088.192.182.28.28M46.48 5.51A16.41 16.41 0 0 0 28.2 3.87C10.72 9.1 11.44 31.68 22.05 41.63c5.12 4.77 12.16 6.76 19.93 3 0 0 9.26-6 11.51-11.24A22.822 22.822 0 0 0 55.35 27a25.27 25.27 0 0 0-1.76-12.63 20 20 0 0 0-8.05-9.42"
        fill="#2BA168"
      />

      <path
        d="M39.49 63.39a5.34 5.34 0 0 1-1.35-4.32 7 7 0 0 1 2.12-3.46 16 16 0 0 0 3.92-5.24c.84-2.13 1.14-3.77.24-5.34 0 0-.83-.89-.13-1.55a1.18 1.18 0 0 1 1.78 0c4.19 3 5.21 5.7 5.69 7.67.48 1.97.59 4.48-.57 6.13a15.228 15.228 0 0 1-3.19 3.6 13.999 13.999 0 0 0-3 2.95 6.59 6.59 0 0 0-1.52 3.77c.035 1.1.356 2.171.93 3.11-1.4-.7-2.55-1-3.49-2.33-.69-.93-2-3.52-1.48-5M46.07 5.51c-4.49-3-9-4.32-13.82-3.36a16 16 0 0 0-4.7 1.72v0c-5.42 1.61-8.1 4.84-10.31 8.84-5 9-3.38 22 4.09 28.92 5.16 4.77 12.32 6.76 20.2 3 0 0 9.38-6 11.66-11.23a22.67 22.67 0 0 0 1.9-6.4 25 25 0 0 0-1.78-12.64 22 22 0 0 0-7.24-8.85v0Z"
        stroke="#272C33"
        strokeWidth={1.58}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M36.16 50.92c-1.5-.05-2.994-.238-4.46-.56a16.001 16.001 0 0 1-7.32-4 15.702 15.702 0 0 1-3.81-5.54 6.46 6.46 0 0 1-5.11-4.05 4.651 4.651 0 0 1-.21-2.66A3.149 3.149 0 0 1 16.81 32a2.81 2.81 0 0 1 2.37-.07 23.65 23.65 0 0 1 1.43-14 14.81 14.81 0 0 1 3.5-5.16A14.39 14.39 0 0 1 32 9.42a42.48 42.48 0 0 1 8.66 0"
        fill="#fff"
      />

      <path
        d="M34.06 50.92c1.5-.05 2.993-.238 4.46-.56a16 16 0 0 0 7.32-4 15.68 15.68 0 0 0 3.8-5.54 6.46 6.46 0 0 0 5.11-4.05 4.59 4.59 0 0 0 .25-2.65A3.14 3.14 0 0 0 53.43 32a2.79 2.79 0 0 0-2.38 0 23.56 23.56 0 0 0-1.43-14c-.78-1.95-1.97-3.71-3.49-5.16a14.51 14.51 0 0 0-7.9-3.33 43.21 43.21 0 0 0-8.66 0"
        fill="#fff"
      />

      <path
        d="M30.89 50.19a17.35 17.35 0 0 1-6.42-3.79 16.11 16.11 0 0 1-3.93-5.72 6.679 6.679 0 0 1-5.27-4.18 4.931 4.931 0 0 1-.27-2.74 3.273 3.273 0 0 1 1.61-2.17 2.941 2.941 0 0 1 2.46-.07c-.3-2.71-.74-9.22 2.09-15.09a14.74 14.74 0 0 1 3.72-5.06 13 13 0 0 1 5.37-2.68c4.81-1.17 9.8-.27 11 .51"
        stroke="#272C33"
        strokeWidth={1.58}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M39 50.11a17.31 17.31 0 0 0 6.41-3.79 16.18 16.18 0 0 0 3.93-5.71 6.7 6.7 0 0 0 5.28-4.19 4.8 4.8 0 0 0 .23-2.73 3.25 3.25 0 0 0-1.6-2.17 2.899 2.899 0 0 0-2.46-.07c.31-2.71.76-9.23-2.07-15.1A14.997 14.997 0 0 0 45 11.3a14.258 14.258 0 0 0-5.38-2.68c-4.35-1.31-8.13 0-10.79.57"
        stroke="#272C33"
        strokeWidth={1.58}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M28.67 23.73a6.7 6.7 0 0 0-4.4 1.86M41.38 23.73a6.72 6.72 0 0 1 4.4 1.86"
        stroke="#272C33"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M32.24 42a2.78 2.78 0 0 0 .93 2.45 3.54 3.54 0 0 0 3.59.26A3 3 0 0 0 38 42c-1.81-.06-4 0-5.76 0ZM35.07 37.51a4.42 4.42 0 0 0 0 1.7"
        stroke="#272C33"
        strokeWidth={1.26}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M27.52 35.64c.895 0 1.62-.922 1.62-2.06s-.725-2.06-1.62-2.06c-.895 0-1.62.922-1.62 2.06s.725 2.06 1.62 2.06Z"
        fill="#272C33"
      />

      <path
        d="m26.16 31.77.54.6"
        stroke="#272C33"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M41.97 35.64c.895 0 1.62-.922 1.62-2.06s-.725-2.06-1.62-2.06c-.895 0-1.62.922-1.62 2.06s.725 2.06 1.62 2.06Z"
        fill="#272C33"
      />

      <path
        d="m43.33 31.77-.54.6"
        stroke="#272C33"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M46.7 27.59a20 20 0 0 1-10.23-4.75 19.93 19.93 0 0 1-5.72-8.66 20.22 20.22 0 0 1-3.45 8.73 20.44 20.44 0 0 1-9.76 7.41c-.9-.49-.22-.55-.57-1.52a17.65 17.65 0 0 1-.76-3.29 20.486 20.486 0 0 1 .4-4.55c.177-.888.41-1.763.7-2.62a22.26 22.26 0 0 1 3.05-6.59 16.49 16.49 0 0 1 5.94-4.9 19 19 0 0 1 8.63-2.22c.863 0 1.725.06 2.58.18a18.06 18.06 0 0 1 8.62 3.88 19.577 19.577 0 0 1 4.26 4.59 19.06 19.06 0 0 1 2.44 15.14c-.15.47-.66 2.07-.93 2 0 0-.06-.05-.08-.08"
        fill="#2BA168"
      />

      <path d="M38 16.32a29.35 29.35 0 0 0 13.63 14L38 16.32Z" fill="#2BA168" />

      <path
        d="M18.4 30c7.3-3.81 11.22-8.15 12.22-16.19.32.947.708 1.869 1.16 2.76a22.454 22.454 0 0 0 4.28 5.9 20.46 20.46 0 0 0 10.64 5.12"
        stroke="#272C33"
        strokeWidth={1.58}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M38 16.32a29.3 29.3 0 0 0 13.58 14"
        stroke="#272C33"
        strokeWidth={1.58}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

const Memo = memo(SvgHello);

export default Memo;
